import React from "react";
/***
 *
 *   PAGINATE
 *   Pagination control to split results into multiple pages
 *   Returns a new offset
 *
 *   PROPS
 *   total: the total number of results
 *   limit: the number of results per page
 *   offset: the current position
 *
 **********/

import { useState, useEffect } from "react";
import { Icon } from "components/lib";

type PaginateProps = {
  total: number;
  limit: number;
  page: number;
  onChange: (page: number) => void;
  className?: string;
};

export function Paginate(props: PaginateProps) {
  const [page, setPage] = useState<any>(props.page);
  const [totalPages, setTotalPages] = useState<any>(1);

  useEffect(() => {
    if (props.total) setTotalPages(props.total);
  }, [props.total]);

  function prev() {
    if (page > 1) {
      setPage(page - 1);
      props.onChange((page - 1));
    }
  }

  function next() {
    if (page < totalPages) {
      setPage(page + 1);
      props.onChange((page + 1));
    }
  }

  return (
    <div
      className={"flex items-center " + props.className}
    >
      <button
        className="border"
        style={{ padding: "3px 7px", borderRadius: 5, height: 30 }}
        onClick={prev}
        disabled={page === 1}
      >
        <Icon image="arrow-left" />
      </button>
      Page:
      <input
        min={1}
        max={totalPages}
        onChange={(e) => setPage(e.target.value)}
        type="number"
        className="border flex justify-center align-center"
        style={{
          paddingTop: 3,
          paddingBottom: 3,
          width: 30,
          borderRadius: 5
        }}
        value={page}
      />
      <p>of</p>
      <p>{totalPages}</p>
      <button
        className="border"
        style={{ padding: "3px 7px", borderRadius: 5, height: 30 }}
        onClick={next}
        disabled={page === totalPages}
      >
        <Icon image="arrow-right" />
      </button>
    </div>
  );
}
